

import React from "react";
import { cn } from "../utils";

type Props = {
  children: React.ReactNode;
  className?: string;
  noMargin?: boolean;
};

function SubHeading({ children, className, noMargin }: Props) {
  return (
    <h3
      className={cn(
        "block text-18 leading-7 font-medium text-secondary",
        !noMargin && "mb-2",
        className,
      )}
    >
      {children}
    </h3>
  );
}

export { SubHeading };

